var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row px-5 mt-5"},[(_vm.data)?_c('div',{staticClass:"col-12",domProps:{"innerHTML":_vm._s(_vm.data)}}):_vm._e(),_vm._v(" "),(!_vm.data)?_c('div',{staticClass:"col-12"},[_c('h1',[_vm._v("Esta sección aún esta pendiente de edición por parte del administrador.")])]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }